/**
 * Given a block with a background color, this extension will change the
 * background color of the block over time to another color. This color will
 * persist across page loads so that other blocks with the same background
 * color will also change if they have the same modifier class.
 *
 * Example: This block has a background color of 'accent':
 * <div class="bg-color-change--contrast"></div>
 *
 * This block's backgorund color will change to the 'contrast' color and back
 * to 'accent' over time. This will be saved in local storage as
 * 'bg-color-change--accent--contrast' to allow for simple access of the
 * changing value across page loads.
 */
document.addEventListener('DOMContentLoaded', () => {

	// Get all blocks that contain background color change modifier class.
	const modifierText = 'bg-color-change--';
	const blocks = Array.from(document.querySelectorAll(`[class*="${modifierText}"]`));

	// If no blocks are found, return early.
	if (!blocks.length) {
		return;
	}

	console.log(blocks);
});
